import _styled from '@emotion/styled/base';
import { keyframes } from '@emotion/react';
import { ScrollArea } from '../ScrollArea/index.js';
import { spacing, border, motion } from '@hubble/tokens/web';

const closeBottom = keyframes`
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(-8px) scale(0.95);
  }
`;
const openBottom = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;
const closeTop = keyframes`
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(8px) scale(0.95);
  }
`;
const openTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;
const HoverCardStyles = _styled(ScrollArea, {
  target: "ex1ozks0"
})("display:flex;flex-direction:column;padding:", spacing[8], ";border-radius:", border.radius.md, ";width:", ({
  width
}) => width ? width : '256px', ";max-height:", ({
  height
}) => height ? height : '384px', ";z-index:9999;background-color:", ({
  theme
}) => theme.colorScheme.elevated.background.menu, ";box-shadow:", ({
  theme
}) => theme.isDark ? '0' : '0px 8px 24px 0px rgba(103, 104, 104, 0.16), 0px 4px 8px 0px rgba(103, 104, 104, 0.12), 0px 0px 0px 1px rgba(103, 104, 104, 0.04)', ";@media (prefers-reduced-motion: no-preference){animation-duration:", motion.duration.intermediate, ";animation-timing-function:cubic-bezier(0.2, 0.8, 0.4, 1);&[data-state='open']{&[data-side='top']{animation-name:", openTop, ";}&[data-side='bottom']{animation-name:", openBottom, ";}}&[data-state='closed']{&[data-side='top']{animation-name:", closeTop, ";}&[data-side='bottom']{animation-name:", closeBottom, ";}}}");

export { HoverCardStyles };
